import {css} from 'styled-components';

import type {Props} from './types';

import {getColor} from '../../styles';

export const skeletonStyle = css<Props>`
  overflow: hidden;
  border-radius: ${p => (p.circle ? 9999 : p.borderRadius || 0)}px;
  width: ${p => (p.size || p.width ? `${p.size || p.width}px` : '100%')};
  height: ${p => p.size || p.height || 18}px;
  background-color: ${p => p.boneColor || getColor('background2')};
`;
